import { gql } from '@apollo/client'

export const LSS_INTEGRATION_STATUS_QUERY = gql`
  query LssIntegrationStatusQuery {
    lssIntegrationStatus {
      sms {
        provider
        configured
        ready
        message
      }
      email {
        provider
        configured
        ready
        message
      }
      ai {
        provider
        configured
        ready
        message
      }
      inboundWebhooks {
        sendrcs
        microsoftGraph
        genericSms
        genericEmail
      }
    }
  }
`

export const SUPPORT_CONVERSATIONS_QUERY = gql`
  query SupportConversationsQuery(
    $filter: SupportConversationFilterInput
    $limit: Int
    $offset: Int
  ) {
    supportConversations(filter: $filter, limit: $limit, offset: $offset) {
      hasMore
      conversations {
        id
        channel
        externalId
        subject
        status
        followUpDate
        draftReply
        lastMessageAt
        lastInboundMessageAt
        lastOutboundMessageAt
        sentPreview
        preview
        contactLookup {
          source
          matches {
            source
            firstName
            clubName
            username
            teamName
            assortmentName
            isSellingPeriodActive
            createdAt
          }
        }
        messages {
          id
          direction
          messageType
          body
          subject
          fromAddress
          toAddress
          toAddresses
          ccAddresses
          sentByName
          createdAt
          attachments {
            id
            name
            contentType
            sizeBytes
            securityStatus
            securityReason
          }
        }
      }
    }
  }
`

export const SUPPORT_CONVERSATION_QUERY = gql`
  query SupportConversationQuery($id: String!) {
    supportConversation(id: $id) {
      id
      channel
      externalId
      subject
      status
      followUpDate
      draftReply
      lastMessageAt
      lastInboundMessageAt
      lastOutboundMessageAt
      sentPreview
      preview
      contactLookup {
        source
        matches {
          source
          firstName
          clubName
          username
          teamName
          assortmentName
          isSellingPeriodActive
          createdAt
        }
      }
      messages {
        id
        direction
        messageType
        body
        subject
        fromAddress
        toAddress
        toAddresses
        ccAddresses
        sentByName
        createdAt
        attachments {
          id
          name
          contentType
          sizeBytes
          securityStatus
          securityReason
        }
      }
    }
  }
`

export const SUPPORT_CONVERSATION_LOOKUPS_QUERY = gql`
  query SupportConversationLookupsQuery {
    supportConversationLookups {
      id
      channel
      externalId
    }
  }
`

export const ADMIN_NAV_COUNTS_QUERY = gql`
  query AdminNavCountsQuery {
    adminNavCounts {
      messagesToHandle
      inquiriesToHandle
      packingDiscrepanciesToHandle
    }
  }
`

export const UPDATE_SUPPORT_STATUS = gql`
  mutation UpdateSupportConversationStatus(
    $id: String!
    $input: UpdateSupportConversationStatusInput!
  ) {
    updateSupportConversationStatus(id: $id, input: $input) {
      id
      status
      followUpDate
    }
  }
`

export const UPDATE_SUPPORT_DRAFT = gql`
  mutation UpdateSupportConversationDraft($id: String!, $draftReply: String!) {
    updateSupportConversationDraft(id: $id, draftReply: $draftReply) {
      id
      draftReply
    }
  }
`

export const SEND_SUPPORT_REPLY = gql`
  mutation SendSupportReply($input: SendSupportReplyInput!) {
    sendSupportReply(input: $input) {
      id
      body
      createdAt
    }
  }
`

export const DELETE_SUPPORT_CONVERSATION = gql`
  mutation DeleteSupportConversation($id: String!) {
    deleteSupportConversation(id: $id)
  }
`

export const GENERATE_SUPPORT_DRAFT = gql`
  mutation GenerateSupportDraft(
    $conversationId: String!
    $waitForAi: Boolean
    $manual: Boolean
  ) {
    generateSupportDraft(
      conversationId: $conversationId
      waitForAi: $waitForAi
      manual: $manual
    ) {
      id
      draftReply
    }
  }
`

export const CREATE_SUPPORT_CONVERSATION = gql`
  mutation CreateSupportConversation($input: CreateSupportConversationInput!) {
    createSupportConversation(input: $input) {
      id
      externalId
      channel
      messages {
        direction
      }
    }
  }
`

export const DOWNLOAD_SUPPORT_ATTACHMENT = gql`
  query DownloadSupportAttachment($id: String!, $acknowledgedRisk: Boolean) {
    supportAttachmentDownload(id: $id, acknowledgedRisk: $acknowledgedRisk) {
      filename
      contentType
      contentBase64
      securityStatus
      securityReason
    }
  }
`
